module.exports = __webpack_public_path__ + "static/media/d.56ecab68.jpg";